import { createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { hasPermission } from "~/store/usePermissionStore";
import { CustomUiSettingsPage } from "~/pages/custom-ui-settings";
export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/plugins")({
  validateSearch: (search: Record<string, unknown>): { pluginId?: string } => ({
    pluginId: typeof search.pluginId === "string" && search.pluginId.trim() ? search.pluginId : undefined,
  }),
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions());
    if (!hasPermission({ role: session.user?.role, permissions: session.user?.permissions }, "plugins", "view"))
      throw redirect({ to: "/$datasetSlug/chats", params: { datasetSlug: params.datasetSlug } });
  },
  component: CustomUiSettingsPage,
});
